import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import {
  primaryButtonStyles,
  textButtonStyles,
} from "../../../../../Constants/buttonStyles";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import { Clear } from "@mui/icons-material";
import theme from "../../../../../Constants/theme";

const AddUsersToGroup = ({
  openUsersDialog,
  setOpenUsersDialog,
  loadingUsersDialog,
  usersList,
  handleUserCheckboxChange,
  selectedUsers,
  handleAddUsers,
}) => {
  return (
    <Dialog
      open={openUsersDialog}
      onClose={() => setOpenUsersDialog(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: dialogStyles.dialogRoot }}
    >
      <DialogTitle sx={{ ...dialogStyles.dialogTitle, mb: 2 }}>
        <IconButton
          onClick={() => setOpenUsersDialog(false)}
          sx={{ ...dialogStyles.dialogCloseIcon, right: 4, top: 0 }}
        >
          <Clear />
        </IconButton>

        <Typography sx={dialogStyles.dialogTitleText}>
          Select Users to Add
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ ...dialogStyles.dialogContent, maxHeight: 400 }}>
        {loadingUsersDialog ? (
          <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        ) : usersList.length > 0 ? (
          <Box display="flex" flexDirection="column">
            {usersList.map((user) => (
              <FormControlLabel
                key={user._id.$oid}
                control={
                  <Checkbox
                    checked={selectedUsers.includes(user._id.$oid)}
                    onChange={() => handleUserCheckboxChange(user._id.$oid)}
                    sx={{
                      color: theme.main.primaryBlue,
                      "&.Mui-checked": {
                        color: theme.main.primaryBlue,
                      },
                    }}
                  />
                }
                label={
                  <Box>
                    <Typography
                      sx={{
                        color: theme.textColors.dark.primary,
                        fontWeight: 500,
                      }}
                    >
                      {user.first_name} {user.last_name}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: theme.typography.fontSize.xs,
                        color: theme.textColors.dark.secondary,
                        mt: "2px",
                      }}
                    >
                      {user.email}
                    </Typography>
                  </Box>
                }
              />
            ))}
          </Box>
        ) : (
          <Typography sx={{ color: theme.textColors.dark.primary }}>
            No users available.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={dialogStyles.dialogActions}>
        <Button onClick={() => setOpenUsersDialog(false)} sx={textButtonStyles}>
          Close
        </Button>
        <Button
          onClick={handleAddUsers}
          sx={primaryButtonStyles}
          disabled={selectedUsers.length === 0}
        >
          Add Users
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUsersToGroup;
